import { Controller } from '@hotwired/stimulus';

/**
 * This controller sets Gmaps options. Connect it to the <gmp-map> element.
 *
 * Connects to data-controller="gmaps-options"
 */
export default class extends Controller {
  static values = { options: Object };

  connect() {
    this.element.innerMap.setOptions(this.optionsValue);
  }
}
